import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const BriefHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './brief-hub-page.vue');
};

export const briefHubRoute: RouteRecordRaw = {
    ...ROUTE_DATA.BRIEF_HUB_PAGE,
    components: {
        main: BriefHub
    }
};
